import { analytics } from './analytics';

export function stickyHeader(b){
	function throttle(callback, limit) {
		var wait = false;
		return function() {
			if (wait) return;
			callback.call();
			wait = true;
			setTimeout(function(){
				wait = false;
			}, limit);
		}
	}

	function sticker(){
		let header = document.querySelector(".site-header.not-top"),
			menu = document.getElementById("navigation-container");

		if (header != null) {
			let box = menu.getBoundingClientRect();

			if (menu.style.top == "") {
				let dimen = header.getBoundingClientRect();

				menu.style.top = `${header.offsetHeight + dimen.top}px`;
			}
		} else {
			if (menu.style.top != "") {
				menu.style.top = "";
			}
		}
	}

	// for mobile expansion, otherwise collapse
	function button(){
		let navBtn = document.getElementById('usmca--mobile-nav'),
			nav = document.querySelector("#holder nav"),
			menu = document.querySelector("#holder nav ul"),
			items = menu.querySelectorAll("li");

		navBtn.addEventListener("click", e => {
			toggleMenu();
			nav.classList.contains("open") ? navBtn.innerText = "" : navBtn.innerText = b.history.current.name;
		});

		items.forEach(item => {
			item.addEventListener("click", () => {
				toggleMenu();
			})
		})

		function toggleMenu(){
			nav.classList.toggle("open");
			menu.classList.toggle("open");
		}
	}

	button();

	window.addEventListener("scroll", throttle(sticker, 100));
}
